import React, { useEffect, useState } from "react";
import { CloudDownload, CheckCircle2 } from "lucide-react";
import { subscribePrefetch } from "@/lib/offlinePrefetch";

export default function OfflinePrepProgress() {
  const [st, setSt] = useState({ running: false, finished: false, pct: 0 });
  const [hide, setHide] = useState(false);

  useEffect(() => subscribePrefetch(setSt), []);
  useEffect(() => {
    if (st.running) setHide(false);
    if (st.finished) {
      const t = setTimeout(() => setHide(true), 4000);
      return () => clearTimeout(t);
    }
  }, [st.running, st.finished]);

  if ((!st.running && !st.finished) || hide) return null;
  const done = st.finished;

  return (
    <div data-testid="offline-prep-bar" className="w-full bg-slate-900 text-white text-xs px-4 py-1.5">
      <div className="max-w-[1400px] mx-auto flex items-center gap-3">
        {done
          ? <CheckCircle2 className="h-3.5 w-3.5 text-emerald-400 shrink-0" />
          : <CloudDownload className="h-3.5 w-3.5 text-sky-300 shrink-0 animate-pulse" />}
        <span className="shrink-0 font-medium hidden sm:inline" data-testid="offline-prep-text">
          {done ? "Offline-Daten bereit – App vollständig offline nutzbar" : "Offline-Daten werden geladen …"}
        </span>
        <span className="shrink-0 font-medium sm:hidden">{done ? "Offline bereit" : "Lade offline …"}</span>
        <div className="flex-1 h-1.5 rounded-full bg-white/15 overflow-hidden">
          <div className="h-full bg-sky-400 transition-all duration-300"
            style={{ width: `${done ? 100 : st.pct}%` }} data-testid="offline-prep-fill" />
        </div>
        <span className="shrink-0 font-mono-tech tabular-nums w-9 text-right" data-testid="offline-prep-pct">
          {done ? 100 : st.pct}%
        </span>
      </div>
    </div>
  );
}
